let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4g2Mj"), load("aDV08")]).then(() => parcelRequire('ef32u'));